import { defineComponent, h, withDirectives, resolveDirective } from 'vue';
import { QInput } from 'quasar';
import BaseComponent from './baseFormMixin.jsx';
import utils from '../../../Shared/utils.jsx';

import { appSettings } from '@/Shared/appSettings.js';
import TranslationContainer from './../TranslationContainer.jsx';

export default defineComponent({
    name: 'sform-time',
    mixins: [BaseComponent],
    components: {
        TranslationContainer,
        QInput,
    },
    data: () => ({
    }),
    props: {
    },
    created() {
    },
    mounted() {
        this.loadComplete();
    },
    computed: {
        itemvalue_aslocaldatetime: function () {
            // Cannot use ISO format directly "2200-07-22T06:00:00Z"
            // The format is "yyyy-MM-ddThh:mm" followed by optional ":ss" or ":ss.SSS".
            utils.debug(`itemvalue_aslocaldatetime: ${this.itemvalue}`);

            let dt;
            if (this.itemvalue)
                dt = new Date(Date.parse(this.itemvalue));
            else
                return null;

            const h = dt.getHours().toString();
            const m = dt.getMinutes().toString();
            const s = dt.getSeconds().toString();
            return `${h.padStart(2, '0')}:${m.padStart(2, '0')}:${s.padStart(2, '0')}`;
        },
        // Same defensive pattern as formSingleDatePicker.jsx / formDateRangePicker.jsx
        // (CCDEV-18145): QField/native input model-value here is a locally-formatted
        // display string, not necessarily the raw stored value. Validate this.itemvalue
        // directly so a future stricter format/pattern check can't silently fail here.
        rules() {
            const r = [];
            if (this.element?.required)
                r.push(() => {
                    const v = this.itemvalue;
                    return (v === null || v === undefined || v === '') ? 'Required' : true;
                });

            if (this.element?.schema)
                r.push(() => {
                    const errors = utils.schema.performValidation(this.element.schema, this.itemvalue);
                    return errors.length > 0 ? errors[0].error : true;
                });

            return r;
        },
    },
    methods: {
        sync_fromlocaldatetime(value) {
            // Native Clear sets "" — do not call toISOString() on Invalid Date.
            if (!value) {
                this.sync(value);
                return;
            }

            if (!value.includes('T'))
                value = '2021-01-01T' + value;

            const dt = new Date(value);
            utils.debug(`sync_fromlocaldatetime:'${value}' as '${dt.toISOString()}'`);
            this.sync(dt.toISOString());
        },
    },
    render() {
        let slots = {
            message: ({message}) => {
                return <TranslationContainer context={this} value={message}></TranslationContainer>
            }
        }
        if (this.hasInputLabel)
            slots.label = () => <TranslationContainer context={this} value={this.labelText}></TranslationContainer>;

        // type=time: do not call showPicker() on field click — that opens the clock
        // popup and steals focus from the hour/minute spinbuttons (blocks typing).
        // Users open the clock via the native picker button; click focuses segments.
        let input = (
            <QInput
                class="caption q-pa-none q-ma-none sform-input-white sform-nativedate-input"
                style={{ width: "100%" }}
                dense
                outlined
                labelSlot={this.hasInputLabel}
                modelValue={this.itemvalue_aslocaldatetime}
                type="time"
                rules={this.rules} {...this.compilerErrorFieldProps}
                onUpdate:modelValue={(value) => this.sync_fromlocaldatetime(value)}
                onBlur={this.onBlur}
                onFocus={this.onFocus}
                hint={this.inputHint}
                hide-hint
                bottom-slots={this.showFieldBottomSlots}
                persistent-hint={appSettings.DebugTranslationPrefixSetting}
            >{slots}</QInput>
        );

        if (this.appearance)
            utils.applyVue2ToVue3Props(input, this.appearance);

        // if (this.directives && this.directives.some(a => a.name == 'on-enter-default'))
        //    input.props.autofocus = true;

        if (this.directives) {
            var applyDirectives = this.directives.map(d => {
                const dirDef = d.directive || resolveDirective(d.name);

                return [dirDef, d.value, d.arg, d.modifiers];
            });
            input = withDirectives(input, applyDirectives);
        }

        return input;
    }
});
